import React, { Component } from 'react';
import { get, has } from "lodash"

import { withStepsState } from "../../../shared/containers/containerStepsState"

import FirstTitle from '../../../shared/items/static/firstTitle';
import InputWrapper from '../../../shared/items/controls/inputWrapper';
import MailNextStepButton from "./mailNextStepButton"
import ValidateMessage from "../../../shared/items/static/validateMessage"
import StepContentWrapper from "../stepContentWrapper"
import StepControl from "../stepControl"
import { isCurrentStep, buildStepClassName, updateOpenStepState } from "../../../shared/services/service.step"
import { steps } from "../../../shared/static.steps"
import { withLoader } from "../../../shared/containers/containerLoader"
import fixFocus from "./../../../utils/fixFocus"
import locales from "./../../../content.json"

import "./../../../shared/services/service.step.scss"
import styles from "./mail.module.scss"

class Mail extends Component {
  constructor() {
    super();

    this.state = {
      isOpenMail: false,
      checked: true,
    }
  }

  componentDidMount() {
    if (isCurrentStep(this.props.currentIndex, steps.mail) && !this.state.isOpenMail)
      this.setState({ isOpenMail: true })
  }

  componentDidUpdate(prevProps) {
    const { currentIndex, data, onSetStepData } = this.props
    const { isOpenMail } = this.state
    const params = {
      currentIndex: currentIndex,
      prevIndex: prevProps.currentIndex,
      stepIndex: steps.mail,
      isOpen: isOpenMail,
      handleChange: this.handleChangeOpen.bind(this),
    }

    if (isOpenMail && !has(data, ["mail"])) {
      onSetStepData("mail")
      document.activeElement.blur()
      fixFocus("mail");
    }

    updateOpenStepState({ params })
  }

  handleChangeOpen(state) {
    this.setState({
      isOpenMail: state,
    })
  }

  render() {
    const { currentIndex, data, onUpdateStepData } = this.props
    const { isOpenMail } = this.state
    const params = {
      className: "wrapperMail",
      currentIndex: currentIndex,
      stepIndex: steps.mail,
    }
    const showWarning = get(data, ["mail", "value"], null)

    let changeCheckbox = () => {
      this.setState({
        checked: !this.state.checked,
      })
    }

    return isOpenMail ?
      <div className={buildStepClassName({ params })}>

        <StepContentWrapper>
          <FirstTitle>{locales[window.userLang].email_title_part_1} <span className={styles.goal}>{data.result.title}</span> {locales[window.userLang].email_title_part_2}</FirstTitle>

          {console.log('this.state.checked:', this.state.checked)}

          <InputWrapper
            name="mail"
            keyName="value"
            placeholder={locales[window.userLang].email_placeholder}
            onChange={onUpdateStepData.bind(this)}
            valueStore={get(data, ["mail", "value"], null)}
          />

          <div className={styles.container_validateMessage}>
          {showWarning && <ValidateMessage message={get(data, ["mail", "validString"], null)} />}
          <div className={styles.warning}>
              <div className={styles.lock}>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="20" viewBox="0 0 14 20" fill="none">
              <path d="M2.00004 8.14836C0.894648 8.152 0 9.14095 0 10.3773V17.7711C0 19.0023 0.897353 20 2.00599 20H11.994C13.1021 20 14 19.0096 14 17.7711V10.3773C14 9.1484 13.1059 8.15132 12 8.14836V5.55497C12 2.48672 9.75587 0 6.99985 0C4.23849 0 1.99974 2.48672 1.99974 5.55497L2.00004 8.14836ZM4.00009 8.14836V5.55632C4.00009 3.71035 5.34343 2.22216 7.00015 2.22216C8.65344 2.22216 10.0002 3.7148 10.0002 5.55632V8.14836H4.00009Z" fill="#C2C2C2"/>
              </svg>
              </div>
              <div>
                {locales[window.userLang].email_description}
              </div>
          </div>
          </div>

          <div>
            <label className={styles.container}>
              <input type="checkbox" checked={this.state.checked} onChange={changeCheckbox} />
              <span className={styles.checkmark}></span>
                {locales[window.userLang].mail_checkbox_text}
            </label>
          </div>

        </StepContentWrapper>

        <StepControl>
          <MailNextStepButton>{locales[window.userLang].continue}</MailNextStepButton>
        </StepControl>
      </div>
      : null
  }
}

export default withStepsState(withLoader(Mail));